export default __webpack_public_path__ + "static/media/garuda-usdt.5dfd54ee.png";